import React, {useState, useEffect} from 'react'
import { Title } from '../../components/JurosCompostos/Title'
import { MoneySelect } from '../../components/JurosCompostos/MoneySelect'
import { Period } from '../../components/JurosCompostos/Period'
import { Rentabilidade } from '../../components/JurosCompostos/Rentabilidade'
import { Button } from '../../components/JurosCompostos/Button'
import { LineChart } from '../../components/JurosCompostos/LineChart'
import { Table } from '../../components/JurosCompostos/Table'
import CloseIcon from './closeIcon.svg'
import styles from './index.module.css'
import ApiSuno from '../../api/services/ApiSuno';
import ApiSunoProvider from '../../api/providers/ApiSuno';

var moment = require('moment');

export const JurosCompostos = (props) => {
    const apiSuno = new ApiSuno();
    const [investimento, setInvestimento] = useState(0)
    const [investimentoValid, setInvestimentoValid] = useState(true)
    const [investimentoErrorText, setInvestimentoErrorText] = useState('')
    const [aplicacao, setAplicacao] = useState(0)
    const [aplicacaoValid, setAplicacaoValid] = useState(true)
    const [aplicacaoErrorText, setAplicacaoErrorText] = useState('')
    const [periodText, setPeriodText] = useState(0)
    const [periodSelect, setPeriodSelect] = useState(1)
    const [periodValid, setPeriodValid] = useState(true)
    const [rentabilidadeText, setRentabilidadeText] = useState(0)
    const [rentabilidadeSelect, setRentabilidadeSelect] = useState(12)
    const [rentabilidadeValid, setRentabilidadeValid] = useState(true)
    const [valorFinal, setValorFinal] = useState(0)
    const [valorInvestido, setValorInvestido] = useState(0)
    const [showChart, setShowChart] = useState(true)
    const [showChartAndTable, setShowChartAndTable] = useState(false)
    const [periodoChart, setPeriodoChart] = useState(0)
    const [dadosCalculoGrafico, setDadosCalculoGrafico] = useState([])
    const [dadosCalculo, setDadosCalculo] = useState([])

    const handleInvestimentoChange = (value) => {
        setInvestimentoValid(true)
        setInvestimentoErrorText('')
        setInvestimento(parseFloat(value.replaceAll('.','').replaceAll(',','.')))
        setAplicacaoValid(true)
    }

    const handleAplicacaoChange = (value) => {
        setAplicacaoValid(true)
        setAplicacaoErrorText('')
        setAplicacao(parseFloat(value.replaceAll('.','').replaceAll(',','.')))
        setInvestimentoValid(true)
    }

    const handlePeriodText = (value) => {
        setPeriodValid(true)
        setPeriodText(value)
    }
    const handlePeriodoSelect = (value) => {
        setPeriodSelect(value)
    }

    const handleRentabilidadeText = (value) => {
        setRentabilidadeValid(true)
        setRentabilidadeText(value)

    }
    const handleRentabilidadeSelect = (value) => {
        setRentabilidadeSelect(value)
    }

    const handleCalculateButton = () => {
        if(parseFloat(investimento) === 0 && parseFloat(aplicacao) === 0){
          setInvestimentoErrorText("Preencha esse campo")
          setInvestimentoValid(false)
          setAplicacaoErrorText("Preencha esse campo")
          setAplicacaoValid(false)
        } else if(parseInt((periodText === '')?0:periodText) === 0){
          setPeriodValid(false)
        } else if(parseFloat(rentabilidadeText.replace('.','').replace(',','.')) === 0){
          setRentabilidadeValid(false)
        } else{
          let period = parseInt((periodText === '')?0:periodText) * parseInt(periodSelect)
          let rentabilidade = (rentabilidadeText === '')?0:parseFloat(rentabilidadeText.replace('.','').replace(',','.'))/100
          if(parseInt(rentabilidadeSelect) === 12){
              rentabilidade = Math.pow((1+rentabilidade),(1/12))-1
          }
          calculoJurosComposto(rentabilidade, parseFloat(investimento), parseFloat(aplicacao), period)
        }
    }

    const handleShowChart = () => {
      setShowChart(!showChart)
    }

    function calculoJurosComposto(rentabilidade, investimentoInic, aportes, periodo){
        let data = moment()
        let total = investimentoInic
        let linhaJuros = [];
        let linhaInvestimento = [];
        let linhaJurosChart = [];
        let linhaInvestimentoChart = [];
        let chartCount = controlePeriodo(periodo, 0);
        // Adiciona primeiro dado ao array de dados
        linhaJuros.push({"x": moment(data).format('MMM YYYY'), "y": total.toFixed(2)});
        linhaInvestimento.push({"x": moment(data).format('MMM YYYY'), "y": total.toFixed(2)});
        // Adiciona primeiro dado ao array do grafico
        if(periodo < 36){
          linhaJurosChart.push({"x": dateFormat(periodo, data), "y": total.toFixed(2)});
          linhaInvestimentoChart.push({"x": dateFormat(periodo, data), "y": total.toFixed(2)});
        }
        for (let count = 1; count <= periodo; count++) {
            total = total * (1+rentabilidade) + aportes
            data = moment(data).add(1,'M')
            // Adiciona dado ao array de dados
            linhaJuros.push({"x": moment(data).format('MMM YYYY'), "y": total.toFixed(2)})
            linhaInvestimento.push({"x": moment(data).format('MMM YYYY'), "y": parseFloat(investimentoInic + (aportes*count)).toFixed(2)})
            if(count === chartCount){
              // Adiciona dado ao array do grafico
              linhaJurosChart.push({"x": dateFormat(periodo, data), "y": total.toFixed(2)});
              linhaInvestimentoChart.push({"x": dateFormat(periodo, data), "y": parseFloat(investimentoInic + (aportes*count)).toFixed(2)})
              chartCount = controlePeriodo(periodo, chartCount)
            }
        }
        
        setPeriodoChart(periodo)
        setDadosCalculo([
            {
                "id": "Acumulado",
                "data": linhaJuros
            },
            {
                "id": "Investido",
                "data": linhaInvestimento
            }])
            console.log(linhaJuros)
        setDadosCalculoGrafico([
          {
            "id": "Acumulado",
            "data": linhaJurosChart
          },
          {
              "id": "Investido",
              "data": linhaInvestimentoChart
          }])
        setShowChartAndTable(true)
        setValorFinal(parseFloat(total).toFixed(2))
        setValorInvestido(parseFloat(investimentoInic + (aportes * periodo)))
        return parseFloat(total).toFixed(2)
    }

    function dateFormat(periodo, date){
      if(periodo >= 36){
        return moment(date).format('YYYY')
      } else{
        return moment(date).format('MMM YYYY')
      }
    }

    // Função utilizada para controlar por periodo os dados que seram exibidos no gráfico
    function controlePeriodo(periodo, value){
      let data = moment()
      if(periodo <= 12){
        value++
      } else if(periodo <= 24){
        value += 2
      } else if(periodo < 36){
        value += 6
      } else if(periodo <= 144){
        if(value === 0){
          value = 12 - parseInt(data.format('M'))
        } else {
          value += 12
        }
      } else{
        if(value === 0){
          value = 12 - parseInt(data.format('M'))
        } else {
          value += (parseInt(parseInt(periodText)/12) * 2) * 12
        }
      }
      if(value > periodo){
        value = periodo
      }
      return value
    }

    return (
        <div className={styles.main}>
            <div className={styles.calculator} style={(showChartAndTable)?{borderBottomLeftRadius: '0px', borderBottomRightRadius: '0px'}:{},(window.screen.width <= 768 && showChartAndTable)?{display:'none'}:{}}>
              <Title>Calculadora de juros compostos</Title>
              <div className={styles.calculatorFields}>
                <div className={styles.params}>
                    <div className={styles.paramsfield}>
                      <MoneySelect 
                          min={0}
                          max={2000}
                          maxValueAllow={999999.99}
                          initial={investimento}
                          label='Investimento inicial'
                          onChange={handleInvestimentoChange}
                          valid={investimentoValid}
                          errorMessage={investimentoErrorText}
                      />
                    </div>
                    <div className={styles.paramsfield}>
                      <MoneySelect 
                          min={0}
                          max={400}
                          maxValueAllow={999999.99}
                          initial={aplicacao}
                          label='Aplicação Mensal'
                          onChange={handleAplicacaoChange}
                          valid={aplicacaoValid}
                          errorMessage={aplicacaoErrorText}
                      />
                    </div>
                </div>
                <div className={styles.paramsMobile}>
                      <Period 
                          label='Período'
                          onChangeText={handlePeriodText}
                          onChangeSelect={handlePeriodoSelect}
                          valueText={periodText}
                          valueSelect={periodSelect}
                          valid={periodValid}
                      />
                    
                      <Rentabilidade 
                          label='Rentabilidade' 
                          onChangeText={handleRentabilidadeText}
                          onChangeSelect={handleRentabilidadeSelect}
                          valueText={rentabilidadeText}
                          valueSelect={rentabilidadeSelect}
                          valid={rentabilidadeValid}
                      />
                    
                </div>
              </div>
              <div>
                  <Button onClick={handleCalculateButton}>CALCULAR</Button>
              </div>
            </div>
            {(showChartAndTable)?
              <div className={styles.chartAndTable}>
                <div className={styles.titleRow}>
                  <Title color='#fff'>Simulação de rentabilidade </Title>
                  {(window.screen.width <= 768)?
                    <div onClick={()=>{setShowChartAndTable(false)}}>
                      <CloseIcon fill="white"/>
                    </div>
                  :null}
                </div>
                {(showChart)?(<LineChart data={dadosCalculoGrafico} valorFinal={valorFinal} valorInvestido={valorInvestido} periodo={periodoChart} changeViewType={handleShowChart}/>)
                :<Table Investimento={dadosCalculo[1]} Acumulado={dadosCalculo[0]} changeViewType={handleShowChart}/>}
              </div>
            :null}
        </div>
    )
}
